module.exports = __webpack_public_path__ + "img/muscles_quiz_button_2.8da80045.jpg";